<div class="class-wrapper">
  <app-status-messages
    [msgs]="msgs"
    [btnLabel]="btnLabel"
    [continueType]="continueType"
    (targetAction)="handleIncomingAction($event)"
  ></app-status-messages>
  <div class="modal-header text-center">
    <h4 class="modal-title w-100">{{ type }} Event Prop</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="eventPropFrame.hide()"
      mdbTooltip="Close"
      placement="bottom"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body mt-3 p-0">
    <div class="row mb-3">
      <div class="col-12 event-properties">
        <form [formGroup]="eventPropForm">
          <div class="md-form">
            <input
              type="text"
              id="propLabel"
              class="form-control"
              formControlName="label"
              mdbInput
            />
            <label for="propLabel">Label</label>
          </div>

          <div class="md-form">
            <button
              mdbBtn
              class="info-button color-theme-base-medium"
              mdbPopover="Note: Name is a code-friendly reference for this property. Name should only contain numbers, leters, and underscores, and it must be unique across the entire Admin Panel System."
              placement="right"
              mdbPopoverHeader="About the Name Field"
              triggers="focus"
              mdbWavesEffect
            >
              <mdb-icon fas icon="info-circle"></mdb-icon>
            </button>
            <input
              type="text"
              id="propName"
              class="form-control"
              formControlName="name"
              mdbInput
            />
            <label for="propName">Name</label>
          </div>

          <div class="md-form">
            <input
              type="text"
              id="propDescription"
              class="form-control"
              formControlName="description"
              mdbInput
            />
            <label for="propDescription">Description</label>
          </div>

          <div class="md-form">
            <mdb-select
              [options]="propsTypes"
              id="constainedTypes"
              formControlName="type"
              mdbInput
              placeholder="Choose type"
              (selected)="selectedType($event)"
              label="Property Type"
            ></mdb-select>
          </div>

          <div class="md-form" *ngIf="eventPropForm.value.type == 'asset'">
            <mdb-select
              [options]="assetSelect"
              id="propSubType"
              formControlName="subtype"
              placeholder="Choose sub type"
              mdbInput
            ></mdb-select>
            <label for="propSubType">Subtype</label>
          </div>

          <!--form value for order, a number input-->
          <div class="md-form">
            <input
              type="number"
              id="propOrder"
              class="form-control"
              formControlName="order"
              mdbInput
            />
            <label for="propOrder">Order</label>
          </div>
          <!--end order-->

          <div class="md-form">
            <mdb-checkbox
              id="propsConstained"
              class="form-control border-0"
              formControlName="constrained"
              (click)="updateConstained()"
              mdbInput
              >Constrained</mdb-checkbox
            >
            <!-- <label for="propsConstained">Constrained</label> -->
          </div>

          <div class="md-form" *ngIf="eventPropForm.controls.constrained">
            <input
              type="text"
              id="propType"
              class="form-control"
              formControlName="constrainedValue"
              mdbInput
            />
            <label for="propType">Default Value</label>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer">
      <button
        mdbBtn
        mdbWavesEffect
        type="button"
        size="md"
        data-dismiss="modal"
        (click)="addEventProps()"
        class="theme-modal-button btn"
      >
        {{ type }}
      </button>
      <button
        mdbBtn
        mdbWavesEffect
        type="button"
        size="md"
        color="link"
        data-dismiss="modal"
        (click)="eventPropFrame.hide()"
      >
        Close
      </button>
    </div>
  </div>
</div>
